import * as customs from './customs'

export default { customs}
